import { render, staticRenderFns } from "./ApmsRegCanteenRequisition.vue?vue&type=template&id=72b38cf5&scoped=true&"
import script from "./ApmsRegCanteenRequisition.vue?vue&type=script&lang=js&"
export * from "./ApmsRegCanteenRequisition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b38cf5",
  null
  
)

export default component.exports